import firebase from '@firebase/app';

export const registerUser = (user, callback) => {
  user.date_request_accept = firebase.firestore.FieldValue.serverTimestamp();

  return firebase.firestore().collection("professors")
    .doc(user.professor_code)
    .collection("users_requesitions").add(user)
    .then(function (response) {

      console.log("RESPONDE ID: " + response.id);

      firebase.firestore().collection("userWithProfessors")
        .doc(response.id).set({
          professor: user.professor_code,
        })
        .catch((error) => {
          console.log(error)
          callback(error, false)
        })
        .then((response) => {
          callback(response, true);
        })


    }).catch(function (error) {

      console.error("Error writing document: ", error);
      callback();
    });
}

export const getProfessor = (student, callback) => {

  return firebase.firestore().collection("userWithProfessors")
    .doc(student).get()
    .then(function (response) {

      console.log("Document successfully written!: " + response);
      callback(response, true);

    }).catch(function (error) {

      console.error("Error writing document: ", error);
      callback(error, false);

    });
}

export const checkCodeProfessor = (code, callback) => {

  return firebase.firestore().collection("professors")
    .doc(code)
    .update({ check_code: true })
    .then(function () {
      console.log("Document successfully written!");
      callback(true);

    }).catch(function (error) {

      console.error("Error writing document: ", error);
      callback(false);
    });
}

export const checkExistsRequest = (code, email, callback) => {

  return firebase.firestore().collection("professors")
    .doc(code)
    .collection("users_requesitions").where("email", "==", email)
    .get()
    .then(function (response) {
      console.log("RESPONSE: ");
      console.log(response.docs);
      if (response && response.docs && response.docs.length > 0) {
        callback(false, "Pedido já enviado para este email, aguarde a aceitação do professor!")
      } else {
        callback(true, "");
      }

    }).catch(function (error) {

      console.error("Error writing document: ", error);
      callback(false, "Verifique sua internet");
    });
}

export const registerFinalUser = (uidProfessor, uid, user, callback) => {
  user.date_request_accept = firebase.firestore.FieldValue.serverTimestamp();
  return firebase.firestore().collection("professors")
    .doc(uidProfessor)
    .collection("users")
    .doc(uid)
    .set(user)
    .then(function (response) {
      console.log("Document successfully written!");
      callback(response, true);

    }).catch(function (error) {

      console.error("Error writing document: ", error);
      callback(error.message, false);
    });
}

export const removeUser = (uidProfessor, uid, newUid, callback) => {
  return firebase.firestore()
    .collection("professors").doc(uidProfessor)
    .collection("users_requesitions")
    .doc(uid).delete()
    .catch((error) => {
      console.error(error)
      callback(false)
    })
    .then(() => {

      //Removendo userWithProfessors
      firebase.firestore()
        .collection("userWithProfessors").doc(uid)
        .delete()
        .catch((error) => {
          console.error(error)
          callback(false)
        })
        .then(() => {

          //Recriando o userWithProfessors
          firebase.firestore().collection("userWithProfessors")
            .doc(newUid).set({
              professor: uidProfessor,
            })
            .catch((error) => {
              console.log(error)
              callback(false)
            })
            .then((response) => {
              callback(true);
            })

        })

    })
}

export const usersRequesitionsList = (uidProfessor, callback) => {
  return firebase.firestore().collection("professors").doc(uidProfessor)
    .collection("users_requesitions")
    .orderBy('name')
    .onSnapshot((snapshot) => {
      let itens = []
      snapshot.forEach(doc => {
        //console.log(doc.id, '=>', doc.data());
        itens.push({
          id: doc.id,
          data: doc.data(),
        })
      });
      callback(itens)
    }, (error) => {
      console.log('Error getting documents', error);
    });

}

export const usersList = (uidProfessor, callback) => {
  return firebase.firestore()
    .collection("professors")
    .doc(uidProfessor)
    .collection("users")
    .where("status", ">=", "ACTIVE")
    .where("status", "<=", "INATIVE")
    // .orderBy('status')
    // .orderBy('name')
    .onSnapshot((snapshot) => {
      let itens = []
      snapshot.forEach(doc => {
        //console.log(doc.id, '=>', doc.data());
        itens.push({
          id: doc.id,
          data: doc.data(),
        })
      });
      callback(itens)
    }, (error) => {
      console.log('Error getting documents', error);
    });

}

//Pdfs do perfil do usuário
export const sendPdfMultipleFileStorage = (id_user, type_pdf, file, nameSeconds, callback) => {

  let metadata = {
    contentType: 'application/pdf',
  };

  let uploadTask = firebase.storage().ref('pdfs_evaluations/' + id_user + '/' + type_pdf + '/' + nameSeconds).put(file, metadata);

  return uploadTask.on('state_changed', function (snapshot) {
    // Observe state change events such as progress, pause, and resume
    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
    var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
    console.log('Upload is ' + progress + '% done');
    switch (snapshot.state) {
      case firebase.storage.TaskState.PAUSED: // or 'paused'
        console.log('Upload is paused');
        break;
      case firebase.storage.TaskState.RUNNING: // or 'running'
        console.log('Upload is running');
        break;
    }
  }, function (error) {
    // Handle unsuccessful uploads
    console.log("ERROR: " + error)
    callback(error.message, false);

  }, function () {
    console.log("SUCCESS")
    // Handle successful uploads on complete
    // For instance, get the download URL: https://firebasestorage.googleapis.com/...
    uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
      console.log('File available at', downloadURL);
      callback(downloadURL, true);
    });
  });
}

//Pdfs do perfil do usuário
export const deletePdfEvaluationFileStorage = (id_user, type_pdf, nameSeconds, callback) => {

  const pathToRemove = 'pdfs_evaluations/' + id_user + '/' + type_pdf.toString().toUpperCase() + '/' + nameSeconds;
  console.log("Path to remove: ", pathToRemove);

  let deleteTask = firebase.storage().ref(pathToRemove);

  // Delete the file
  deleteTask.delete().then(() => {
    // File deleted successfully
    callback('Removido com sucesso', true);
  }).catch((error) => {
    // Uh-oh, an error occurred!
    console.log("ERROR: ", error);
    callback(error.message, false);
  })
}


//Pdfs do perfil do usuário
export const sendPdfFileStorage = (id_user, type_pdf, file, callback) => {

  let metadata = {
    contentType: 'application/pdf',
  };

  let uploadTask = firebase.storage().ref('pdfs/' + id_user + '/' + type_pdf).put(file, metadata);

  return uploadTask.on('state_changed', function (snapshot) {
    // Observe state change events such as progress, pause, and resume
    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
    var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
    console.log('Upload is ' + progress + '% done');
    switch (snapshot.state) {
      case firebase.storage.TaskState.PAUSED: // or 'paused'
        console.log('Upload is paused');
        break;
      case firebase.storage.TaskState.RUNNING: // or 'running'
        console.log('Upload is running');
        break;
    }
  }, function (error) {
    // Handle unsuccessful uploads
    console.log("ERROR: " + error)
  }, function () {
    console.log("SUCCESS")
    // Handle successful uploads on complete
    // For instance, get the download URL: https://firebasestorage.googleapis.com/...
    uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
      console.log('File available at', downloadURL);
    });
  });
}

//Video de exercícios
export const sendGifFileStorage = (uidProfessor, file, uidExercise, callback) => {

  let metadata = {
    contentType: 'image/gif',
  };

  let uploadTask = firebase.storage().ref('gifs_exercises/' + uidProfessor + '/' + uidExercise).put(file, metadata);

  return uploadTask.on('state_changed', function (snapshot) {
    // Observe state change events such as progress, pause, and resume
    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
    var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
    console.log('Upload is ' + progress + '% done');
    switch (snapshot.state) {
      case firebase.storage.TaskState.PAUSED: // or 'paused'
        console.log('Upload is paused');
        break;
      case firebase.storage.TaskState.RUNNING: // or 'running'
        console.log('Upload is running');
        break;
    }
  }, function (error) {
    // Handle unsuccessful uploads
    console.log("ERROR: " + error)
    callback(error, true)
  }, function () {
    console.log("SUCCESS")
    // Handle successful uploads on complete
    // For instance, get the download URL: https://firebasestorage.googleapis.com/...
    uploadTask.snapshot.ref.getDownloadURL()
      .then(function (downloadURL) {
        console.log('File available at', downloadURL);

        callback(downloadURL, true)
      });
  });
}

//Video de exercícios
export const sendImagePublication = (uidProfessor, file, uidPublication, callback) => {

  let metadata = {
    contentType: 'image/jpeg',
  };

  let uploadTask = firebase.storage().ref('images_publications/' + uidProfessor + '/' + uidPublication).put(file, metadata);

  return uploadTask.on('state_changed', function (snapshot) {
    // Observe state change events such as progress, pause, and resume
    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
    var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
    console.log('Upload is ' + progress + '% done');
    switch (snapshot.state) {
      case firebase.storage.TaskState.PAUSED: // or 'paused'
        console.log('Upload is paused');
        break;
      case firebase.storage.TaskState.RUNNING: // or 'running'
        console.log('Upload is running');
        break;
    }
  }, function (error) {
    // Handle unsuccessful uploads
    console.log("ERROR: " + error)
    callback(error, true)
  }, function () {
    console.log("SUCCESS")
    // Handle successful uploads on complete
    // For instance, get the download URL: https://firebasestorage.googleapis.com/...
    uploadTask.snapshot.ref.getDownloadURL()
      .then(function (downloadURL) {
        console.log('File available at', downloadURL);

        callback(downloadURL, true)
      });
  });
}

//Fotos do perfil
export const getUrlProfilePic = (uidUser, callback) => {

  let uploadTask = firebase.storage().ref('images_profile/' + uidUser + ".jpg");
  console.log("id: ", uidUser);
  console.log("uploadTask: ", uploadTask);
  uploadTask.getDownloadURL()
    .then(function (downloadURL) {
      console.log('File available at', downloadURL);

      callback(downloadURL);
    });
}


// WEBPACK FOOTER //
// src/dao-firebase/daofirebase.js